
import axios from 'axios';
 
export const setAuthToken = (token : string | null) => {
    if (token) {
        axios.defaults.headers.common["x-access-token"] = token;
        localStorage.setItem('buamatog-access-token', token);
    } else {
        delete axios.defaults.headers.common["x-access-token"];
        localStorage.removeItem('buamatog-access-token');
    }
}